import * as React from 'react';
import { createSelector } from 'reselect';
import { useSelector, useDispatch } from 'react-redux';
import SharingDialog from '../../features/Sharing/SharingDialog';
import { closeShareDialog } from '../../../services/store/modules/sharing';
import { ROUTE_LOGIN } from '../../../services/route/route-names';
import { transitionToNextRoute } from '../../../services/route/route-navigation';
import { telemetry } from '../../../services/backend';

const sharingSelector = (state) => state.sharing;
const currentMemberSelector = (state) => state.backendService.currentMember;
const isOpenSelector = createSelector(sharingSelector, (item) => item.isOpen);
const markerDetails = createSelector(
  sharingSelector,
  ({ sharePath, socialText, title, description, type, id }) => ({
    sharePath,
    socialText,
    title,
    description,
    type,
    id,
  }),
);

const ConnectedSharingDialog = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(isOpenSelector);
  const shareDetails = useSelector(markerDetails);
  const currentMemberDetails = useSelector(currentMemberSelector);

  // if we try to open sharing and are not a signed in user
  // redirect to login
  if (isOpen && !currentMemberDetails) {
    telemetry(
      telemetry.INFO,
      `LOGIN_REDIRECT: Sharing dialogue - redirecting to login`,
    );
    transitionToNextRoute(ROUTE_LOGIN);
    return null;
  }

  return (
    <SharingDialog
      isOpen={isOpen}
      closeAction={() => dispatch(closeShareDialog())}
      path={shareDetails.sharePath}
      socialText={shareDetails.socialText}
      title={shareDetails.title}
      description={shareDetails.description}
      type={shareDetails.type}
      id={shareDetails.id}
      currentMemberImage={currentMemberDetails?.image}
      currentMemberUsername={currentMemberDetails?.username}
      currentMemberTitle={currentMemberDetails?.title}
    />
  );
};

export default ConnectedSharingDialog;
